import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCompass, FiSearch, FiLayers } = FiIcons;

const ServiceModel = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">Sie entscheiden, wie tief wir gehen.</h2>
            <p className="text-lg text-gray-600">Drei Ebenen der Zusammenarbeit – passend zu Ihrer Situation.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all border border-transparent hover:border-azure-200">
              <div className="w-12 h-12 bg-azure-600 text-white rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={FiCompass} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4">1. Orientierung</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Einordnung Ihrer Situation, Aufzeigen möglicher Wege und fundierte Entscheidungshilfe.
              </p>
              <span className="text-azure-600 font-bold text-xs uppercase tracking-widest">Kostenloses Erstgespräch</span>
            </div>

            <div className="p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all border border-transparent hover:border-azure-200">
              <div className="w-12 h-12 bg-azure-600 text-white rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={FiSearch} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4">2. Analyse & Klärung</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                IST-Situation verstehen, Kernprozesse identifizieren und die logische Entscheidungsreife prüfen.
              </p>
              <span className="text-azure-600 font-bold text-xs uppercase tracking-widest">Strategie-Phase</span>
            </div>

            <div className="p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all border border-transparent hover:border-azure-200">
              <div className="w-12 h-12 bg-azure-600 text-white rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={FiLayers} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4">3. Architektur</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Entwurf der Systemarchitektur, Gestaltung des Veränderungsprozesses und Umsetzungsplan.
              </p>
              <span className="text-azure-600 font-bold text-xs uppercase tracking-widest">Veränderungs-Prozess</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceModel;